import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicesRoutingModule } from './services-routing.module';
import { ServicesListComponent } from './services-list/services-list.component';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ComponentsModule } from '../components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { RatingModule } from 'primeng/rating';
import { ServiceDetailsComponent } from './services-list/service-details/service-details.component';
import { ServiceCategoryComponent } from './service-category/service-category.component';
import { ServiceCategoryCreateComponent } from './service-category/service-category-create/service-category-create.component';
import { OrderListModule } from 'primeng/orderlist';
import { ServiceOverviewComponent } from './services-list/service-details/service-overview/service-overview.component';
import { ServicePricingComponent } from './services-list/service-details/service-pricing/service-pricing.component';
import { ServiceScopingComponent } from './services-list/service-details/service-scoping/service-scoping.component';
import { ServiceTransportationComponent } from './services-list/service-details/service-transportation/service-transportation.component';
import { ServiceActionBarComponent } from './services-list/service-details/service-action-bar/service-action-bar.component';
import { ServiceUnitsOfChargeComponent } from './service-units-of-charge/service-units-of-charge.component';
import { AddRegionComponent } from './services-list/service-details/service-scoping/add-region/add-region.component';
import { ServiceOrdersModule } from './service-orders/service-orders.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [ServicesListComponent, ServiceDetailsComponent, ServiceCategoryComponent, ServiceCategoryCreateComponent, ServiceOverviewComponent, ServicePricingComponent, ServiceScopingComponent, ServiceTransportationComponent, ServiceActionBarComponent, ServiceUnitsOfChargeComponent, AddRegionComponent],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    ProgressSpinnerModule,
    ComponentsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    RatingModule,
    OrderListModule,
    ServiceOrdersModule,
    MultiSelectModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAPS_KEY,
      libraries: ['places'],
    }),
  ]
})
export class ServicesModule { }
